import { ErrorResetBoundary } from "@/components/shared/ErrorResetBoundary";
import { AdminBanner } from "@/components/shared/layout/AdminBanner";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/auth/useAuth";
import { BreadcrumbProvider } from "@/contexts/shared/breadcrumb";
import { Outlet } from "react-router";
import { RuntimeProvider } from "../chat/components/RuntimeProvider";
import { FrontEndSideNav } from "./FrontEndSideNav";
import { FrontEndTopBar } from "./FrontEndTopBar";

const FrontEndLayout = () => {
    const { user } = useAuth();

    const topOffset = user?.is_admin
        ? "calc(var(--header-height) + var(--admin-bar-height))"
        : "var(--header-height)";

    return (
        <div
            className="flex h-screen flex-col"
            style={{ "--top-offset": topOffset } as React.CSSProperties}
        >
            <BreadcrumbProvider>
                <SidebarProvider className="flex flex-col">
                    <FrontEndTopBar />
                    <AdminBanner />
                    <div className="flex min-h-0 flex-1">
                        <FrontEndSideNav />
                        <SidebarInset className="min-w-0">
                            <div className="flex min-h-0 min-w-0 flex-1 flex-col">
                                <ErrorResetBoundary>
                                    <RuntimeProvider>
                                        <Outlet />
                                    </RuntimeProvider>
                                </ErrorResetBoundary>
                            </div>
                        </SidebarInset>
                    </div>
                </SidebarProvider>
            </BreadcrumbProvider>
        </div>
    );
};

export default FrontEndLayout;
